export default __webpack_public_path__ + "locales/az/VersionHistory.json?hash=a0361f1a767e29e001f404aaf7b6806c";